import { environment } from "../main";
import { Services } from "./services";

export interface GetSnippetRequestBody {
    language: string;
    email: string;
    products: [
        {
            Name: string;
            Id: string;
        }
    ];
}

export interface GetSnippetResponseBody {
    version?: string;
    snippet?: string;
}

export class ProductComparatorsService {
    constructor(private _services: Services, private _config?: any) {}

    async init() {
        if (upgates) {
            if (upgates.pageType === "order.recieved") {
                const htmlSnippet = await this.getHtmlSnippetForPriceComparators();
                $(`head`).append(htmlSnippet);
            }
        }
        return this;
    }

    getApiBaseUrl() {
        if (environment === "development") {
            return "https://api-test.uderman.sk/api/";
        } else {
            return "https://api.uderman.sk/api/";
        }
    }

    getOrderItems() {
        const products: Array<{ Id: string; Name: string }> = [];
        products.push(...(upgates?.order?.products || []).map(prod => ({ Id: prod.code, Name: prod.title })));
        return products;
    }

    async getHtmlSnippetForPriceComparators() {
        let htmlSnippet = "";

        const requestPayload = {
            language: this._services.getLanguage(),
            email: upgates?.order?.customer?.email || "",
            products: this.getOrderItems()
        };
        const snippetResponse = await fetch(this.getApiBaseUrl() + "v1/product-comparators/get-snippet", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(requestPayload)
        });
        const textSnippetResponse = await snippetResponse.text();
        let jsonSnippetResponse: GetSnippetResponseBody = {};
        try {
            jsonSnippetResponse = JSON.parse(textSnippetResponse);
            htmlSnippet = jsonSnippetResponse?.snippet || "";
        } catch (error) {
            console.log(error);
        }

        return htmlSnippet;
    }
}
